(function () {
  var selector = 'input[data-sold-by][data-min-qty]';
  var invalidMessage = 'Quantity must be at least {min} and sold by {step}.';

  function toPositiveInteger(value, fallback) {
    var parsed = parseInt(value, 10);

    if (Number.isNaN(parsed) || parsed < 1) {
      return fallback;
    }

    return parsed;
  }

  function getRules(input) {
    return {
      soldBy: toPositiveInteger(input.dataset.soldBy, 1),
      minQty: toPositiveInteger(input.dataset.minQty, 1),
    };
  }

  function getCurrentValue(input) {
    return parseInt(input.value, 10);
  }

  function getNextValidQuantity(value, rules) {
    var quantity = toPositiveInteger(value, rules.minQty);

    if (quantity < rules.minQty) {
      quantity = rules.minQty;
    }

    if (quantity % rules.soldBy !== 0) {
      quantity = Math.ceil(quantity / rules.soldBy) * rules.soldBy;
    }

    if (quantity < rules.minQty) {
      quantity = Math.ceil(rules.minQty / rules.soldBy) * rules.soldBy;
    }

    return quantity;
  }

  function isValidQuantity(input) {
    var rules = getRules(input);
    var value = getCurrentValue(input);

    if (Number.isNaN(value)) {
      return false;
    }

    if (value < rules.minQty) {
      return false;
    }

    return value % rules.soldBy === 0;
  }

  function getErrorElement(input) {
    var id = input.id ? input.id + '-QuantityError' : '';
    var existing = id ? document.getElementById(id) : null;

    if (existing) {
      return existing;
    }

    var error = document.createElement('p');
    error.className = 'quantity-rule-error';
    error.setAttribute('role', 'alert');
    error.hidden = true;

    if (id) {
      error.id = id;
      input.setAttribute('aria-describedby', [input.getAttribute('aria-describedby'), id].filter(Boolean).join(' '));
    }

    input.insertAdjacentElement('afterend', error);

    return error;
  }

  function setError(input, message) {
    var error = getErrorElement(input);

    if (message) {
      error.textContent = message;
      error.hidden = false;
      input.setAttribute('aria-invalid', 'true');
    } else {
      error.textContent = '';
      error.hidden = true;
      input.removeAttribute('aria-invalid');
    }
  }

  function validateInput(input, shouldCorrect) {
    var rules = getRules(input);
    var value = getCurrentValue(input);
    var isValid = isValidQuantity(input);
    var message = (input.dataset.errorMessage || invalidMessage)
      .replace('{min}', rules.minQty)
      .replace('{step}', rules.soldBy);

    if (!isValid) {
      setError(input, message);

      if (shouldCorrect) {
        input.value = getNextValidQuantity(value, rules);
        setError(input, '');
        isValid = true;
      }
    } else {
      setError(input, '');
    }

    return isValid;
  }

  function getCartForms() {
    return Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart"]'));
  }

  function getCheckoutButtons(form) {
    return Array.prototype.slice.call(
      form.querySelectorAll('button[name="checkout"], input[name="checkout"], [data-checkout-button]')
    );
  }

  function updateCheckoutState() {
    getCartForms().forEach(function (form) {
      var inputs = Array.prototype.slice.call(form.querySelectorAll(selector));
      var hasInvalidQuantity = inputs.some(function (input) {
        return !isValidQuantity(input);
      });

      getCheckoutButtons(form).forEach(function (button) {
        button.disabled = hasInvalidQuantity;
        button.setAttribute('aria-disabled', String(hasInvalidQuantity));
      });
    });
  }

  function handleInput(event) {
    var input = event.target.closest(selector);

    if (!input) {
      return;
    }

    validateInput(input, false);
    updateCheckoutState();
  }

  function handleChange(event) {
    var input = event.target.closest(selector);

    if (!input) {
      return;
    }

    validateInput(input, true);
    updateCheckoutState();
  }

  function handleAdjustClick(event) {
    var button = event.target.closest('[data-quantity-adjust]');

    if (!button) {
      return;
    }

    var wrapper = button.closest('.quantity-sold-by');
    var input = wrapper ? wrapper.querySelector(selector) : null;

    if (!input) {
      return;
    }

    var rules = getRules(input);
    var direction = parseInt(button.dataset.quantityAdjust, 10);
    var currentValue = getCurrentValue(input);

    if (Number.isNaN(direction)) {
      direction = 1;
    }

    if (Number.isNaN(currentValue)) {
      currentValue = rules.minQty;
    }

    input.value = getNextValidQuantity(currentValue + rules.soldBy * direction, rules);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function handleSubmit(event) {
    var form = event.target;
    var inputs = Array.prototype.slice.call(form.querySelectorAll(selector));
    var hasInvalidQuantity = false;

    inputs.forEach(function (input) {
      if (!validateInput(input, true)) {
        hasInvalidQuantity = true;
      }
    });

    updateCheckoutState();

    if (hasInvalidQuantity) {
      event.preventDefault();
    }
  }

  function init() {
    document.addEventListener('input', handleInput);
    document.addEventListener('change', handleChange);
    document.addEventListener('click', handleAdjustClick);
    document.addEventListener('blur', handleChange, true);

    document.addEventListener('submit', handleSubmit);

    document.querySelectorAll(selector).forEach(function (input) {
      validateInput(input, false);
    });

    updateCheckoutState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
